import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

// @dynamic
@Component({
  selector: 'sc-info-dialog',
  templateUrl: './sc-info-dialog.component.html',
  styleUrls: ['./sc-info-dialog.component.scss']
})
export class ScInfoDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { title: string; text: string; type: number }
  ) {
    if (this.data && this.data.type === 1) {
      try {
        this.data.text = JSON.parse(`[${this.data.text}]`);
      } catch (e) {
        this.data.type = 0; // show it as regular text
      }
    }
  }
}
